<template>
  <div class="switcher">

    <a
      href="#"
      :class="['switcher__lang', { active: lang === 'de' }]"
      @click.prevent="switchLang('de')"
    >
      DE
    </a>
    <span class="switcher__separator">|</span>
    <a
      href="#"
      :class="['switcher__lang', { active: lang === 'en' }]"
      @click.prevent="switchLang('en')"
    >
      EN
    </a>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState(["lang"])
  },
  methods: {
    ...mapMutations(["switchLang"])
  }
};
</script>

<style lang="scss">
.switcher {
  font-size: 36px;
  font-family: Arial, Helvetica, sans-serif;

  &__lang {
    display: inline-block;
    color: #ffffff;
    opacity: 0.5;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: 500;
    margin-left: 10px;
    margin-right: 10px;

    &.active {
      opacity: 1;
    }
  }

  &__separator {
    display: inline-block;
    transform: translateY(-3px);
    color: #ffffff;
  }
}
</style>
